import { useTranslation } from "react-i18next";
import { BsGrid } from "react-icons/bs";

const GallerySizeModal = ({ isOpen, onClose, columns, onChange, isMobile }) => {
  const { t } = useTranslation();
  const minCols = isMobile ? 1 : 3;
  const maxCols = isMobile ? 4 : 6;

  if (!isOpen) return null;

  const ticks = Array.from({ length: maxCols - minCols + 1 }, (_, i) => i + minCols);

  return (
    <>
      <div
        onClick={onClose}
        style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.35)", zIndex: 1050 }}
      />
      <div style={{
        position: "fixed", top: "50%", left: "50%",
        transform: "translate(-50%, -50%)",
        background: "#fff", borderRadius: 14,
        boxShadow: "0 16px 48px rgba(0,0,0,0.16)",
        zIndex: 1055, width: "min(90vw, 380px)", padding: "24px",
      }}>
        {/* Header */}
        <div style={{ display: "flex", alignItems: "center", gap: 9, marginBottom: 4 }}>
          <div style={{
            width: 32, height: 32, borderRadius: 9,
            background: "#eef2ff",
            display: "flex", alignItems: "center", justifyContent: "center",
            flexShrink: 0,
          }}>
            <BsGrid style={{ fontSize: 14, color: "#6366f1" }} />
          </div>
          <h6 style={{ fontWeight: 700, fontSize: 15, margin: 0, color: "#111827" }}>
            {t("gallery_size.title")}
          </h6>
        </div>
        <p style={{ fontSize: 12, color: "#6b7280", margin: "0 0 22px", paddingLeft: 41 }}>
          {t("gallery_size.subtitle")}
        </p>

        {/* Slider */}
        <div style={{ marginBottom: 22 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
            <span style={{ fontSize: 12, color: "#6b7280" }}>{t("gallery_size.columns_label")}</span>
            <span style={{
              fontSize: 13, fontWeight: 700, color: "#6366f1",
              background: "#eef2ff", padding: "2px 12px", borderRadius: 8,
              minWidth: 32, textAlign: "center",
            }}>
              {columns}
            </span>
          </div>
          <input
            type="range"
            min={minCols}
            max={maxCols}
            step={1}
            value={columns}
            onChange={(e) => onChange(Number(e.target.value))}
            style={{ width: "100%", accentColor: "#6366f1", cursor: "pointer" }}
          />
          <div style={{ display: "flex", justifyContent: "space-between", marginTop: 6 }}>
            {ticks.map((n) => (
              <span key={n} style={{
                fontSize: 11, color: n === columns ? "#6366f1" : "#9ca3af",
                fontWeight: n === columns ? 700 : 400,
                transition: "color 0.15s",
              }}>
                {n}
              </span>
            ))}
          </div>
        </div>

        {/* Done button */}
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <button
            onClick={onClose}
            style={{
              padding: "7px 20px", borderRadius: 8,
              border: "1px solid #c7d2fe",
              background: "#eef2ff", color: "#6366f1",
              fontSize: 13, fontWeight: 600, cursor: "pointer",
              transition: "all 0.15s",
            }}
            onMouseEnter={e => { e.currentTarget.style.background = "#e0e7ff"; }}
            onMouseLeave={e => { e.currentTarget.style.background = "#eef2ff"; }}
          >
            {t("gallery_size.done")}
          </button>
        </div>
      </div>
    </>
  );
};

export default GallerySizeModal;
